<template>
  <div class="app-bar-menu">
    <li v-if="canILikeWall">
      <button v-if="isLiked" class="app-bar-button" :title="__('Unlike')" @click="unlikeWall">
        <base-icon name="favorite" class="highlighted-type" />
      </button>
      <button v-else class="app-bar-button" :title="__('Like')" @click="likeWall">
        <base-icon name="favorite_border" />
      </button>
    </li>
    <li v-if="canIRemake">
      <a role="button" target="_blank" :href="remakeUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="remake" />
        <span class="responsive-no-phone-only">{{ __('Remake') }}</span></a
      >
    </li>
    <li>
      <a role="button" target="_blank" :href="shareUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="share_arrow" />
        <span class="responsive-no-phone-only">{{ __('Share') }}</span>
      </a>
    </li>
    <li>
      <a role="button" target="_blank" :href="showUrl" class="app-bar-button" :title="__('Open in new')">
        <base-icon name="open_in_new" />
      </a>
    </li>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters, mapActions } from 'vuex'
import BaseIcon from 'vuecomponents/base_icon'

export default {
  components: { BaseIcon },
  computed: {
    ...mapState(['wall', 'isLikedByCurrentUser']),
    ...mapGetters(['links', 'canIRemake', 'canILikeWall']),
    showUrl() {
      return this.links.show
    },
    remakeUrl() {
      return this.showUrl + '#remake'
    },
    shareUrl() {
      return this.showUrl + '#share'
    },
    isLiked() {
      return this.isLikedByCurrentUser
    },
  },
  methods: {
    ...mapActions(['likeWall', 'unlikeWall']),
  },
}
</script>
